import { useMemo } from 'react';
import type { SpectralWorkspaceSession } from '../types';
import type { SessionFullTractMetrics } from '../utils/computeSessionFullTractMetrics';
import { computeGroupSummary } from '../utils/computeGroupSummary';

export const useWorkspaceGroupSummary = (
  sessions: SpectralWorkspaceSession[],
  metrics: SessionFullTractMetrics[]
) => useMemo(() => computeGroupSummary(sessions, metrics), [metrics, sessions]);
